import { ReducerChain, withScope } from "@gamedev-web/gamedev-sdk-core";

import { IdXboxProgramDataResponse } from "../../server/crm/api/models/idXboxProgramModels";
import { IdXboxProgramActions, idXboxProgramActions } from "../actions/idXboxProgramActions";
import { IdXboxProgramScope } from "../scopes";

export type IdXboxProgramState = {
  data: IdXboxProgramDataResponse | null;
  isLoading: boolean;
  error: string | null;
};

export const initialIdXboxProgramState: IdXboxProgramState = {
  data: null,
  isLoading: false,
  error: null,
};

export const idXboxProgramReducer = withScope(
  [IdXboxProgramScope],
  new ReducerChain<IdXboxProgramState>(initialIdXboxProgramState)
    .on(IdXboxProgramActions.FETCH_DATA_START, state => ({
      ...state,
      isLoading: true,
      error: null,
    }))
    .on(
      IdXboxProgramActions.FETCH_DATA_SUCCESS,
      (state, action: ReturnType<typeof idXboxProgramActions.fetchData.success>) => ({
        ...state,
        isLoading: false,
        data: action.data,
        error: null,
      })
    )
    .on(
      IdXboxProgramActions.FETCH_DATA_ERROR,
      (state, action: ReturnType<typeof idXboxProgramActions.fetchData.error>) => ({
        ...state,
        isLoading: false,
        error: action.error.message,
      })
    )
    .build()
);
